import MicroModal from 'micromodal';

// ログインモーダル
jQuery(function ($) {
  $('.open-modal-login').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-login', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
  $('.open-modal-company-login').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-company-login', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

// 登録モーダル
jQuery(function ($) {
  $('.open-modal-register').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-register', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
  $('.open-modal-company-register').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-company-register', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
  $('.open-modal-sns-register').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      $('#sns').val($(this).data('sns'));
      MicroModal.show('modal-sns-register', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

// 会員登録・ログインモーダル
jQuery(function ($) {
  $('.open-modal-signup-login').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-signup-login', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});
// メールテンプレート選択モーダル
jQuery(function ($) {
  $('.open-modal-mail-template').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-mail-template', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});
// 受付年卒選択モーダル
jQuery(function ($) {
  $('.open-modal-graduation_y').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-graduation_y', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});
// メッセージ確認モーダル（オファー）
jQuery(function ($) {
  $('.open-modal-message-confirm').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      $('#form-confirm-message input[name="user_id"]').val($('#form-send-message input[name="user_id"]').val());
      $('#form-confirm-message textarea[name="body"]').val($('#form-send-message textarea[name="body"]').val());
      MicroModal.show('modal-message-confirm', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

// メッセージ確認モーダル（学生詳細オファー）

if($('#form-send-message').length) {
// テキストエリアに文字が入力されたらメッセージ内容確認ボタンクリック可能
  var btn = $('.message-btn-box.message-confirmation');
  jQuery(window).on('load', function() {
    btn.addClass('disabled');
  });
  jQuery('#offerTextarea').on('input keyup', function() {
    var value = $('#offerTextarea').val();
    var str = value.replace(/\s+/g, "");
    var count = str.length;
    var textareaValue = $('#offerTextarea').val();
    var textareaStr = textareaValue.replace(/\r?\n/g, '');
    var textAreaCount = textareaStr.length;
    if(count == 0 || textAreaCount > 1500) {
      btn.addClass('disabled');
    }else if(count > 0) {
      btn.removeClass('disabled');
    }
  });
  $('.open-modal-message-offer a').on(oEventNames.end, function (event) {
    if (!bIsScrolling ) {
      event.preventDefault();
      // $('.open-modal-message-offer a')をクリックした時に入力されているメッセージの文字数を取得
      var value = $('#offerTextarea').val();
      var str = value.replace(/\s+/g, "");
      var count = str.length;
      if(count > 0) {// テキストエリアに文字が入力されている時だけ実行
        // メッセージ確認モーダルのformのinputとtextareaにvalueを挿入
        $('#form-confirm-message input[name="user_id"]').val($('#form-send-message input[name="user_id"]').val());
        $('#form-confirm-message textarea[name="body"]').val($('#form-send-message textarea[name="body"]').val());
        // 改行を<br>にreplace
        var textValue = $('#form-send-message textarea[name="body"]').val();
        var textValue = textValue.replace(/\r?\n/g, '<br>');
        // モーダルに確認用メッセージテキストを挿入
        $('#form-confirm-message p.js-message-preview').html(textValue);
        // メッセージ確認用モーダルを追加
        MicroModal.show('modal-message-offer', {
          awaitCloseAnimation: true,
          disableScroll: true
        });
      }
    }
  });
}
// メッセージ送信モーダル（企業とつながる）
jQuery(function ($) {
  $('.open-modal-message').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
          $('#form-message #to-name').text($(this).data('company_name'));
          $('#form-message input[name="company_id"]').val($(this).data('company_id'));
          $('#form-message input[name="offer_status"]').val($(this).data('offer_status'));
      MicroModal.show('modal-message', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

// メッセージ確認モーダル（オファーの「ごめんなさい」ボタン）
jQuery(function ($) {
  $('.open-modal-sorry-message').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-offer-sorry', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

// 2択モーダル（OK押下時の挙動は、各々で設定）
jQuery(function ($) {
  $(document).on(oEventNames.end, '.open-modal-confirm', function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      $('#modal-confirm .question strong').text($(this).data('confirm'));
      // モーダル表示
      MicroModal.show('modal-confirm', {
        awaitCloseAnimation: true
      });
    }
  });
});
/*
 * SNSログイン時
 */
jQuery(function ($) {
  $('#sns-register-btn').on('click', function () {
    var sSns = $('#sns-register-form #sns').val();
    var sMember_type_id = $('#sns-register-form input:radio[name="member_type_id"]:checked').val();
    $(location).attr("href", '/login/' + sSns + '?member_type_id=' + sMember_type_id);
  });
});
/*
 * 各種ボタンの説明
 */
jQuery(function ($) {
  $('.description-content').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-description', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

/*
退会
*/
$(function() {
  $('.open-modal-withdrawal').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-withdrawal', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});
/*
プロフィール画像更新モーダル
*/
$(function() {
  if ($('#modal-profile-img').length) {
    $('.open-modal-profile-img').on(oEventNames.end, function (event) {
      if (!bIsScrolling) {
        event.preventDefault();
        MicroModal.show('modal-profile-img', {
          awaitCloseAnimation: true,
          disableScroll: true
        });
      }
    });
  };
});


/*
希望条件・志向編集のクエスチョンを押すと出てくる説明モーダル
*/
$(function() {
  // 応募タイプ
  $('.open-modal-introduction-1').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('introduction-merit-1', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
  // キャリアタイプ
  $('.open-modal-introduction-2').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('introduction-merit-2', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});
